import CrmFeatures from '../components/CrmFeatures.vue'


const path = "/static-public/assets/components/crm-features/";
new Vue({
  el: '#crm-features',
  render: h => h(CrmFeatures)
});


// WEBPACK FOOTER //
// ./src/entry/landing-crm.js